module.exports = __webpack_public_path__ + "static/media/serv-8.3a7ea817.jpg";